<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Falling Woman</h1>
<h3 class="center" style="margin-top:80px;">Pat Murphy</h3>
<p class="center" style="margin-top:80px;"><img alt="logo" src="logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3title_page.vue?166ead5a